import { connect } from 'react-redux';
import { SignInModal as SignInModalComponent } from '@shared/components/modals/signInModal';
const mapStateToProps = (state)=>({
        isConverged: state.config.isConverged
    });
export const SignInModal = connect(mapStateToProps)(SignInModalComponent);
